
export const environment = {
    appName: "HCX",
    production: false,
    // apiUrl:'http://192.168.0.154:8614/', //development
    apiUrl: 'https://hcx-devapi.chipsyservices.com/', //development
    apiPrefix: 'api/v1',
    media_domain: 'https://d2520wtgrz6ixf.cloudfront.net/hcx-development' // dev
};
